import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-width: 550px;
  width: 100%;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 25px;

  @media (max-width: 1000px) {
    width: 100%;
    justify-content: center;
  }

  button {
    max-width: 300px;
    width: 100%;
  }
`;

export const NotResults = styled.div`
  width: 100%;
  display: flex;
`;

export const ContentFilter = styled.div`
  display: flex;
  max-width: 300px;
  width: 100%;

  & svg {
    font-size: 20px;
  }
`;
